import { useEffect, useMemo } from "react";
import styles from "./accounts.module.css";
import MagnifyingGlassIcon from "../Icons/magnifying-glass-icon";
import CustomMultiSelect from "../CommonComponents/select/CustomMultiSelect";
import { useSelector } from "react-redux";
import { plansSelector } from "../../Reducers/plansReducer";

const orderRatingOptions = [
  { value: [4, 5], label: "4-5 Stars" },
  { value: [3, 4], label: "3-4 Stars" },
  { value: [2, 3], label: "2-3 Stars" },
  { value: [1, 2], label: "1-2 Stars" },
  { value: [0, 1], label: "0-1 Stars" }
];

const driverRatingOptions = [
  { value: [4, 5], label: "4-5 Stars" },
  { value: [3, 4], label: "3-4 Stars" },
  { value: [2, 3], label: "2-3 Stars" },
  { value: [1, 2], label: "1-2 Stars" },
  { value: [0, 1], label: "0-1 Stars" }
];

const AccountsControls = ({ getFilter, setFilter }) => {
  const planList = useSelector(plansSelector);

  const planOptions = useMemo(() => {
    return planList.getAllPlanNames().map(planName => ({
      value: planName,
      label: planName,
    }));
  }, [planList]);

  useEffect(() => {
    if (setFilter) {
      const allOrderRatingValues = orderRatingOptions.map(option => option.value);
      setFilter("ORDER_RATING", allOrderRatingValues);
      
      const allDriverRatingValues = driverRatingOptions.map(option => option.value);
      setFilter("DRIVER_RATING", allDriverRatingValues);
      
      const allPlanValues = planOptions.map(option => option.value);
      setFilter("PLAN", allPlanValues);
    }
  }, [setFilter, planOptions]);

  return (
    <div className={styles.accountsControlsContainer}>
      <div className={styles.accountsSearchInputWrapper}>
        <span className={styles.accountsSearchIcon}>
          <MagnifyingGlassIcon />
        </span>
        <input
          className={styles.accountsSearchInput}
          type="text"
          placeholder="Search account"
          value={getFilter("SEARCH") || ""}
          onChange={(e) => setFilter("SEARCH", e.target.value)}
        />
      </div>
      
      <CustomMultiSelect
        options={orderRatingOptions}
        selected={getFilter("ORDER_RATING") || []}
        onSelect={(values) => setFilter("ORDER_RATING", values)}
        label="Order rating"
        AllLabel="All ratings"
        selectClassName={styles.accountsControlsSelect}
        wrapperClassName={styles.accountsControlsSelectWrapper}
      />
      
      <CustomMultiSelect
        options={driverRatingOptions}
        selected={getFilter("DRIVER_RATING") || []}
        onSelect={(values) => setFilter("DRIVER_RATING", values)}
        label="Driver rating"
        AllLabel="All ratings"
        selectClassName={styles.accountsControlsSelect}
        wrapperClassName={styles.accountsControlsSelectWrapper}
      />
      
      <CustomMultiSelect
        options={planOptions}
        selected={getFilter("PLAN") || []}
        onSelect={(values) => setFilter("PLAN", values)}
        label="Plan"
        AllLabel="All plans"
        selectClassName={styles.accountsControlsSelect}
        wrapperClassName={styles.accountsControlsSelectWrapper}
        dropdownClassName={styles.rightMostDropdown}
      />
    </div>
  );
};

export default AccountsControls;
